import axios from 'axios';
import { decodeToken } from 'react-jwt';
import jwtDefaultConfig from "./jwtDefaultConfig";
import { getToken } from "./../utils";
import queryString from "query-string";

// @Utility
import { setStorage, getStorage } from "./../../../@utility/app/storage";
import { normalizeAffiliate } from "./../../../@utility/app/affiliate";
import { trackCustomerOnline } from '../../../@core/services/appService';

// const queryString = require('query-string');
const jwtConfig = { ...jwtDefaultConfig };

function getGeneralToken() {
    return getStorage("generalToken");
}

function getCustomerToken() {
    return getStorageJWT("customerToken");
}

function getStorageJWT(key) {
    try {
        return localStorage.getItem(key);
    }
    catch (e) {
        var nameEQ = key + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }

        return undefined;
    }
}

function setGeneralToken(value) {
    setStorage("generalToken", value);
}

function setAgentHash(value) {
    setStorage("agent_hash", value);
}

function setCustomerToken(value) {
    setStorage("customerToken", value);
}

async function login(data) {
    const { username, password, verify } = data;
    let customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        customerToken = getGeneralToken();
    }

    let myJson = new URLSearchParams({
        "username": username,
        "password": password,
        "verify": verify
    });

    let config = {
        method: jwtConfig.method_post,
        url: jwtConfig.loginEndpoint,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: myJson
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, token } = dataPromise;

    if (code === 200) {
        setCustomerToken(token);
        trackCustomerOnline();

        return code;
    }
    else {
        return code;
    }
}

async function loginLine(data) {
    const { code: codeLine, url } = data;
    let customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        customerToken = getGeneralToken();
    }

    let myJson = new URLSearchParams({
        "code": codeLine,
        // "affiliate": affiliate,
        // "refer": refer,
        // "know_web": know_web,
        "url": url
    });

    let config = {
        method: jwtConfig.method_post,
        url: jwtConfig.loginLine,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: myJson
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, token, result } = dataPromise;

    if (code === 200 && token !== "") {
        if (result === null || result === undefined) {
            setCustomerToken(token);
            trackCustomerOnline();

            return {
                code,
                result
            };
        }
        else {
            return {
                code,
                result
            };
        }
    }
    else {
        return {
            code,
            result
        };
    }
}

async function register(data) {
    const {
        username,
        password,
        phone,
        refer,
        affiliate,
        partner,
        know_web,
        bank,
        bank_account,
        bank_account_name,
        tm_phone,
        allusion
    } = data;
    let customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        customerToken = getGeneralToken();
    }

    let myJson = new URLSearchParams({
        "username": username,
        "password": password,
        "phone": phone,
        "refer": refer,
        "affiliate": normalizeAffiliate(affiliate),
        // ส่งค่าดิบ backend ตัด prefix เองโดยเทียบกับ agent code จริง
        "partner": partner ? partner : "",
        "know_web": know_web,
        "bank_swift": bank,
        "bank_account": bank_account,
        "bank_name": bank_account_name,
        "tm_phone": tm_phone,
        "allusion": allusion
    });

    let config = {
        method: jwtConfig.method_post,
        url: jwtConfig.registerEndpoint,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: myJson
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);

    const { code, token } = dataPromise;
    if (code === 200) {
        setCustomerToken(token);
        trackCustomerOnline();

        return code;
    }
    else {
        return code;
    }
}

async function registerShort(data) {
    const {
        username,
        password,
        affiliate,
        partner,
        refer,
        know_web,
        allusion,
        bank_account,
        bank_name,
        bank_swift,
        fbc,
        keitaro_id,
        voluum_c_id
    } = data;

    let customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        customerToken = getGeneralToken();
    }

    let myJson = {
        "username": username,
        "password": password,
        "refer": refer,
        "affiliate": normalizeAffiliate(affiliate),
        // ส่งค่าดิบ backend ตัด prefix เองโดยเทียบกับ agent code จริง
        "partner": partner ? partner : "",
        "know_web": know_web,
        "bank_swift": bank_swift,
        "bank_account": bank_account,
        "bank_name": bank_name,
        "allusion": allusion,
        "fbc": fbc,
        "keitaro_id": keitaro_id,
        "voluum_c_id": voluum_c_id
    };

    let config = {
        method: jwtConfig.method_post,
        url: jwtConfig.registerEndpointShort,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);

    const { code, token, password: passwordCustomer } = dataPromise;
    if (code === 200) {
        setCustomerToken(token);
        trackCustomerOnline();
        
        return {
            code,
            password: passwordCustomer
        };
    }
    else {
        return {
            code,
            password: null
        };
    }
}

async function checkUsername(data) {
    const {
        username,
        phone
    } = data;
    let customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        customerToken = getGeneralToken();
    }

    let myJson = new URLSearchParams({
        "username": username,
        "phone": phone
    });

    let config = {
        method: jwtConfig.method_post,
        url: jwtConfig.checkAccount,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: myJson
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);

    const { code, token } = dataPromise;
    if (code === 200) {
        setCustomerToken(token);
        return code;
    }
    else {
        return code;
    }
}

async function checkBankAccount(data) {
    const {
        bank,
        bank_account
    } = data;
    let customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        customerToken = getGeneralToken();
    }

    let myJson = new URLSearchParams({
        "account": bank_account,
        "swift": bank
    });

    let config = {
        method: jwtConfig.method_post,
        url: jwtConfig.checkBankAccount,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: myJson
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);

    const { code, token } = dataPromise;
    if (code === 200) {
        setCustomerToken(token);
        return code;
    }
    else {
        return code;
    }
}

function checkExpireToken() {
    let customerToken = getCustomerToken();
    let tokenJson = decodeToken(customerToken);
    let expireToken = tokenJson.exp - 172800;
    let dateCurrent = Math.floor((new Date().getTime()) / 1000);
    if (dateCurrent > expireToken) {
        return true;
    }
    else {
        return false;
    }
}

function checkExpireTokenGeneral() {
    let customerToken = getGeneralToken();
    let tokenJson = decodeToken(customerToken);
    let expireToken = tokenJson.exp - 172800;
    let dateCurrent = Math.floor((new Date().getTime()) / 1000);
    if (dateCurrent > expireToken) {
        return true;
    }
    else {
        return false;
    }
}

async function refreshToken() {
    let customerToken = getCustomerToken();
    let config = {
        method: jwtConfig.method_get,
        url: jwtConfig.refreshToken,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${customerToken}`,
            "Content-Type": jwtConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);

    const { code, token } = dataPromise;
    if (code === 200) {
        setCustomerToken(token);
        return code;
    }
    else {
        return code;
    }
}

async function rememberPassword(username) {
    let myJson = new URLSearchParams({
        "username": username
    });

    let config = {
        method: jwtConfig.method_post,
        url: `/auth/reset-password`,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${getToken()}`,
            "Content-Type": jwtConfig.contentType
        },
        data: myJson
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);

    const { code, token } = dataPromise;
    if (code === 200) {
        setCustomerToken(token);
        return code;
    }
    else {
        return code;
    }
}

// ---------- ยืนยันเบอร์ด้วยรหัส OTP ก่อนสมัครสมาชิก ----------

// token ที่ใช้ยิงเส้น OTP — ยังไม่มี customer จึงตกไปใช้ general token เป็นปกติ
function getAuthToken() {
    const customerToken = getCustomerToken();

    if (customerToken === null || customerToken === undefined) {
        return getGeneralToken();
    }

    return customerToken;
}

// เส้น OTP ทั้งสามใช้ config ชุดเดียวกัน ต่างแค่ path กับ body
function otpConfig(url, myJson) {
    return {
        method: jwtConfig.method_post,
        url: url,
        headers: {
            "Authorization": `${jwtConfig.headerType} ${getAuthToken()}`,
            "Content-Type": jwtConfig.contentType
        },
        data: queryString.stringify(myJson)
    };
}

// ไม่ใช้ .catch((e) => e.response.data) แบบเส้นเก่า เพราะเน็ตหลุดจะไม่มี e.response แล้วโยน TypeError ต่อ
// คืน code 99 ให้ตรงกับ apiReqService เพื่อให้ alertText จัดการต่อได้
function otpRequest(config) {
    return axios(config)
        .then((response) => response.data)
        .catch((e) => (e?.response?.data !== undefined ? e.response.data : { code: 99 }));
}

// ขอรหัส OTP ครั้งแรก — result = { ref, phone, expire_in, expire_at }
// ฟิลด์นอกจาก phone เป็นของเสริม ส่งไปให้ API ตรวจข้อมูลสมัครตั้งแต่ก่อนเผา SMS (ตอบ 14 / 51 / 68)
// ตัวไหนไม่ได้ส่งมาจะเป็น undefined แล้ว queryString.stringify ตัดทิ้งให้เอง = เหมือนเดิมทุกอย่าง
async function registerOtpRequest(data) {
    const { phone, username, bank_account, bank_name, bank_swift } = data;

    return await otpRequest(otpConfig(jwtConfig.registerOtpRequest, {
        "phone": phone,
        "username": username,
        "bank_account": bank_account,
        "bank_name": bank_name,
        "bank_swift": bank_swift
    }));
}

// ส่งรหัสเดิมซ้ำภายใต้ ref เดิม — ได้ไม่เกิน 3 ครั้งต่อ 1 ref
async function registerOtpResend(data) {
    const { phone, ref } = data;

    return await otpRequest(otpConfig(jwtConfig.registerOtpResend, { "phone": phone, "ref": ref }));
}

// ยืนยัน OTP + สมัครสมาชิกในคำขอเดียว — body เหมือน register-short แต่พ่วง phone/ref/otp
// สำเร็จแล้วเซ็ต customerToken ให้เลย เหมือนที่ registerShort ทำ
async function registerOtpVerify(data) {
    const {
        username,
        password,
        affiliate,
        partner,
        refer,
        know_web,
        allusion,
        bank_account,
        bank_name,
        bank_swift,
        fbc,
        keitaro_id,
        voluum_c_id,
        phone,
        ref,
        otp
    } = data;

    let myJson = {
        "username": username,
        "password": password,
        "refer": refer,
        "affiliate": affiliate,
        // ส่งค่าดิบ backend ตัด prefix เองโดยเทียบกับ agent code จริง
        "partner": partner ? partner : "",
        "know_web": know_web,
        "bank_swift": bank_swift,
        "bank_account": bank_account,
        "bank_name": bank_name,
        "allusion": allusion,
        "fbc": fbc,
        "keitaro_id": keitaro_id,
        "voluum_c_id": voluum_c_id,
        "phone": phone,
        "ref": ref,
        "otp": otp
    };

    const dataPromise = await otpRequest(otpConfig(jwtConfig.registerOtpVerify, myJson));

    const { code, token, password: passwordCustomer } = dataPromise;
    if (code === 200 || code === 0) {
        setCustomerToken(token);
        trackCustomerOnline();

        return {
            code,
            password: passwordCustomer
        };
    }
    else {
        return {
            code,
            password: null
        };
    }
}

export {
    getGeneralToken,
    getCustomerToken,
    setGeneralToken,
    setCustomerToken,
    login,
    loginLine,
    register,
    setAgentHash,
    checkExpireToken,
    checkExpireTokenGeneral,
    checkUsername,
    checkBankAccount,
    refreshToken,
    rememberPassword,
    registerShort,
    registerOtpRequest,
    registerOtpResend,
    registerOtpVerify
}